<template>
  <div>
    <img
      v-if="message.primaryImageUrl"
      class="image no-spacing"
      :src="message.primaryImageUrl"
      :alt="`${message.title} image`"
      data-test-id="message-image"
    >

    <div class="section center">
      <h2
        class="title title--2"
        data-test-id="message-title"
      >
        {{ message.title }}
      </h2>
      <p data-test-id="message-body">
        {{ message.bodyContent }}
      </p>
    </div>

    <div
      v-if="message.ctaContent"
      class="section section--half-y-padding section--alt-background"
      data-test-id="message-footer"
    >
      <button
        class="button button--primary button--large"
        type="button"
        data-test-id="message-cta"
        @click="ctaHandler(message.ctaLink)"
      >
        {{ message.ctaContent }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InAppMessage',

    props: {
      message: {
        type: Object,
        required: true
      }
    },

    created() {
      if (!this.message.alwaysShow) this.$store.dispatch('merchant/markMessageSeen', this.message);
    },

    methods: {
      formatRoute(link) {
        const url = new URL(link);

        const searchParams = new URLSearchParams(url.search);

        const query = {};

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of searchParams.entries()) {
          query[key] = value;
        }

        return {
          path: url.pathname,
          query
        };
      },


      ctaHandler(ctaLink) {
        if (ctaLink) {
          const route = this.formatRoute(ctaLink);

          this.$router.push(route);
        }

        this.$closeModal('inAppMessage');
      }
    }
  };
</script>
